import React, { useReducer, useContext } from 'react';

import { firestoreInitialize } from 'config/firebase/client';

import CustomersContext from './CustomersContext';
import CustomersReducer from './CustomersReducer';
import AuthenticationContext from 'context/Authentication/AuthenticationContext';

const CustomersState = (props) => {
    const initialState = {
        getCustomers: {
            customers: [],
            firstCustomer: null,
            lastCustomer: null,
            nextCustomers: null,
            customersFilter: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getCustomersAllMonth: {
            customers: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        getCustomersById: {
            customer: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        createCustomers: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getCustomersExcel: {
            customers: [],
            customersFilter: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        }
    }

    const { authenticatedState } = useContext(AuthenticationContext)

    const [state, dispatch] = useReducer(CustomersReducer, initialState);

    const createCustomersWithExcel = async (data) => {
        dispatch({ type: 'CREATE_CUSTOMERS_LOADING' });

        let db = firestoreInitialize();

        await data.forEach((doc) => {
            db.collection("Dueños").add({
                uid: "",
                nombre: doc.firstname,
                apellido: doc.lastname,
                email: doc.email,
                genero: doc.gender,
                telefono: doc.phone,
                pais: doc.country
            }).then((docRef) => {
                db.collection("Dueños").doc(docRef.id).update({
                    uid: docRef.id
                });
            })
            .catch((error) => dispatch({ type: 'CREATE_CUSTOMERS_ERROR', payload: { code: 'customers/error', message: error } }))
        });

        dispatch({ type: 'CREATE_CUSTOMERS' })
    }

    const createCustomersResetState = () => {
        dispatch({ type: 'CREATE_CUSTOMERS_RESET_STATE' });
    }

    const getCustomers = (nextPage, prevPage, notPagination, country) => {
        dispatch({ type: 'GET_CUSTOMERS_LOADING' });

        if (country) {
            getCustomersPerCountry(nextPage, prevPage, notPagination, country);
        } else if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalCustomers(nextPage, prevPage, notPagination);
        } else {
            getCustomersPerCountry(nextPage, prevPage, notPagination, authenticatedState.user.pais);
        }
    };

    const getGlobalCustomers = (nextPage, prevPage, notPagination) => {
        dispatch({ type: 'GET_CUSTOMERS_LOADING' });

        let db = firestoreInitialize();

        if (notPagination) {
            let first = db.collection("Dueños");

            first.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_CUSTOMERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
            })
            .catch(error => dispatch({ type: 'GET_CUSTOMERS_ERROR', payload: { code: 'customers/error', message: error } }))   
        } else if (nextPage) {
            let first = db.collection("Dueños")
                .orderBy('uid')
                .startAfter(nextPage)
                .limit(10)

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_CUSTOMERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Dueños")
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_CUSTOMERS', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_CUSTOMERS', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_CUSTOMERS_ERROR', payload: { code: 'customers/error', message: error } }))   
        } else if (prevPage) {
            let first = db.collection("Dueños")
                .orderBy('uid')
                .endBefore(prevPage)
                .limitToLast(10);

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_CUSTOMERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Dueños")
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_CUSTOMERS', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_CUSTOMERS', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_CUSTOMERS_ERROR', payload: { code: 'customers/error', message: error } }))   
        } else {
            let first = db.collection("Dueños")
                .limit(10)

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_CUSTOMERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Dueños")
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_CUSTOMERS', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_CUSTOMERS', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_CUSTOMERS_ERROR', payload: { code: 'customers/error', message: error } }))   
        }
    }

    const getCustomersPerCountry = (nextPage, prevPage, notPagination, country) => {
        dispatch({ type: 'GET_CUSTOMERS_LOADING' });

        let db = firestoreInitialize();

        if (notPagination) {
            let first = db.collection("Dueños")
                .where('pais', '==', country)

            first.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_CUSTOMERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
            })
            .catch(error => dispatch({ type: 'GET_CUSTOMERS_ERROR', payload: { code: 'customers/error', message: error } }))   
        } else if (nextPage) {
            db.collection("Dueños")
                .where('uid', '==', nextPage)
                .limit(1)
                .get().then((querySnapshot) => {
                    let first = db.collection("Dueños")
                    .where('pais', '==', country)
                    .startAfter(querySnapshot.docs[0])
                    .limit(10)

                    first.get().then((documentSnapshots) => {
                        if (documentSnapshots.size < 10) {
                            dispatch({ type: 'GET_CUSTOMERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                        } else {
                            const data = documentSnapshots.docs.map(doc => doc.data());
                            const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                            const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                            let nextDocument = db.collection("Dueños")
                                .where('pais', '==', country)
                                .startAfter(last)
                                .limit(1)
                                
                            nextDocument.get().then((documentSnapshots) => {
                                if (documentSnapshots.size === 1) {
                                    dispatch({ type: 'GET_CUSTOMERS', payload: { data: data, first: first, last: last, next: true }});
                                } else {
                                    dispatch({ type: 'GET_CUSTOMERS', payload: { data: data, first: first, last: last, next: false }});
                                }
                            });
                        }
                    })
                })
                .catch(error => dispatch({ type: 'GET_CUSTOMERS_ERROR', payload: { code: 'customers/error', message: error } }))   
        } else if (prevPage) {
            db.collection("Dueños")
                .where('uid', '==', prevPage)
                .limit(1)
                .get().then((querySnapshot) => {

                    let first = db.collection("Dueños")
                    .where('pais', '==', country)
                    .endBefore(querySnapshot.docs[0])

                    first.get().then((documentSnapshots) => {
                        if (documentSnapshots.size < 10) {
                            dispatch({ type: 'GET_CUSTOMERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                        } else {
                            const data = documentSnapshots.docs.map(doc => doc.data());
                            const first = documentSnapshots.docs[documentSnapshots.docs.length=data.length-10];
                            const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                            let nextDocument = db.collection("Dueños")
                                .where('pais', '==', country)
                                .startAfter(last)
                                .limit(1)
                                
                            nextDocument.get().then((documentSnapshots) => {
                                const length = data.length - 10;

                                data.splice(0, length);

                                if (documentSnapshots.size === 1) {
                                    dispatch({ type: 'GET_CUSTOMERS', payload: { data: data, first: first, last: last, next: true }});
                                } else {
                                    dispatch({ type: 'GET_CUSTOMERS', payload: { data: data, first: first, last: last, next: false }});
                                }
                            });
                        }
                    })
                })
                .catch(error => dispatch({ type: 'GET_CUSTOMERS_ERROR', payload: { code: 'customers/error', message: error } }))   
        } else {
            let first = db.collection("Dueños")
                .where('pais', '==', country)
                .limit(10)

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_CUSTOMERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Dueños")
                            .where('pais', '==', country)
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_CUSTOMERS', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_CUSTOMERS', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_CUSTOMERS_ERROR', payload: { code: 'customers/error', message: error } }))   
        }
    }

    const getCustomersExcel = () => {
        dispatch({ type: 'GET_CUSTOMERS_EXCEL_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalCustomersExcel();
        } else {
            getCustomersPerCountryExcel(authenticatedState.user.pais);
        }
    }

    const getGlobalCustomersExcel = () => {
        let db = firestoreInitialize();

        let first = db.collection("Dueños")

            first.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_CUSTOMERS_EXCEL', payload: { data: documentSnapshots.docs.map(doc => doc.data()) } });
            })
            .catch(error => dispatch({ type: 'GET_CUSTOMERS_EXCEL_ERROR', payload: { code: 'customers/error', message: error } }))   
    };

    const getCustomersPerCountryExcel = (country) => {
        let db = firestoreInitialize();

        let first = db.collection("Dueños")
            .where('pais', "==", country)

        first.get().then((documentSnapshots) => {
            dispatch({ type: 'GET_CUSTOMERS_EXCEL', payload: { data: documentSnapshots.docs.map(doc => doc.data()) } });
        })
        .catch(error => dispatch({ type: 'GET_CUSTOMERS_EXCEL_ERROR', payload: { code: 'customers/error', message: error } }))   
    }
    
    const getCustomersById = (id) => {
        dispatch({ type: 'GET_CUSTOMERS_BY_ID_LOADING' });

        let db = firestoreInitialize();

        let docRef = db.collection("Dueños").doc(id);

        docRef.get().then((doc) => {
            if (doc.exists) {
                dispatch({ type: 'GET_CUSTOMERS_BY_ID', payload: doc.data() })
            } else {
                dispatch({ type: 'GET_CUSTOMERS_BY_ID', payload: null })
            }
        }).catch((error) => {
            dispatch({ type: 'GET_CUSTOMERS_BY_ID_ERROR', payload: { code: 'customers/customers-error', message: error }})
        });
    };

    const getCustomersByName = (query) => {
        dispatch({ type: 'GET_CUSTOMERS_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalCustomersByName(query);
        } else {
            getCustomersByNameCountry(query, authenticatedState.user.pais);
        }
    };

    const getGlobalCustomersByName = (query) => {
        let db = firestoreInitialize();

        db.collection('Dueños')
        .get()
        .then((documentSnapshots) => {
            const data = documentSnapshots.docs.map(doc => doc.data());
            let results = [];

            for (let i = 0; i < data.length; i++) {
                let fullName = "";

                if (data[i].nombre && data[i].apellido) {
                    fullName = data[i].nombre + " " + data[i].apellido;
                }

                if (fullName.length > 0 && fullName.toLowerCase().includes(query.toLowerCase())) {
                    results.push(data[i]);
                } else if ((data[i].nombre && data[i].nombre.toLowerCase().includes(query.toLowerCase())) || (data[i].apellido && data[i].apellido.toLowerCase().includes(query.toLowerCase())) || (data[i].email && data[i].email.toLowerCase().includes(query.toLowerCase())) || (data[i].genero && data[i].genero.toLowerCase().includes(query.toLowerCase())) || (data[i].telefono && data[i].telefono.toString().toLowerCase().includes(query.toLowerCase()))) {
                    results.push(data[i]);
                }
            }

            dispatch({ type: 'GET_CUSTOMERS', payload: { data: results, first: null, last: null, next: false }});
        })
        .catch((error) => {
            console.log(error)
            dispatch({ type: 'GET_CUSTOMERS_ERROR', payload: { code: 'customers/error', message: error } })
        })
    }

    const getCustomersByNameCountry = (query, country) => {
        let db = firestoreInitialize();

        db.collection('Dueños')
        .where('pais', '==', country)
        .get()
        .then((documentSnapshots) => {
            const data = documentSnapshots.docs.map(doc => doc.data());
            let results = [];

            for (let i = 0; i < data.length; i++) {
                let fullName = "";

                if (data[i].nombre && data[i].apellido) {
                    fullName = data[i].nombre + " " + data[i].apellido;
                }

                if (fullName.length > 0 && fullName.toLowerCase().includes(query.toLowerCase())) {
                    results.push(data[i]);
                } else if ((data[i].nombre && data[i].nombre.toLowerCase().includes(query.toLowerCase())) || (data[i].apellido && data[i].apellido.toLowerCase().includes(query.toLowerCase())) || (data[i].email && data[i].email.toLowerCase().includes(query.toLowerCase())) || (data[i].genero && data[i].genero.toLowerCase().includes(query.toLowerCase())) || (data[i].telefono && data[i].telefono.toString().toLowerCase().includes(query.toLowerCase()))) {
                    results.push(data[i]);
                }
            }

            dispatch({ type: 'GET_CUSTOMERS', payload: { data: results, first: null, last: null, next: false }});
        })
        .catch((error) => dispatch({ type: 'GET_CUSTOMERS_ERROR', payload: { code: 'customers/error', message: error } }))
    }

    const getCustomersAllMonth = async (country) => {
        dispatch({ type: 'GET_CUSTOMERS_ALL_MONTH_LOADING' });

        if (country) {
            getCustomersAllMonthPerCountry(country);
        } else if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalCustomersAllMonth();
        } else {
            getCustomersAllMonthPerCountry(authenticatedState.user.pais);
        }
    };

    const getGlobalCustomersAllMonth = async () => {
        const year = new Date().getFullYear()

        let db = firestoreInitialize();

        let customersPerMonth = [];

        for (let index = 1; index <= 12; index++) {
            let month;

            if (index < 10) {
                month = `0${index.toString()}`;
            } else {
                month = `${index.toString()}`;
            }

            let convertDateStart = new Date(`${year}-${month}-01`).setHours(0)

            let convertDate = new Date(convertDateStart);

            let startDate;
            let endDate;

            if (index === 1) {
                startDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth() + 1, 0);
            } else {
                startDate = new Date(convertDate.getFullYear(), convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear(), convertDate.getMonth() + 1, 0);
            }

            endDate = endDate.setHours(23,59,59,999)

            await db.collection('Dueños')
            .where('createdOn', '>=', new Date(startDate))
            .where('createdOn', '<=', new Date(endDate))
            .get()
            .then((documentSnapshots) => {
                customersPerMonth.push(documentSnapshots.docs.map(doc => doc.data()))
            })
        }

        dispatch({ type: 'GET_CUSTOMERS_ALL_MONTH', payload: { data: customersPerMonth } });
    }

    const getCustomersAllMonthPerCountry = async (country) => {
        const year = new Date().getFullYear()

        let db = firestoreInitialize();

        let customersPerMonth = [];

        for (let index = 1; index <= 12; index++) {
            let month;

            if (index < 10) {
                month = `0${index.toString()}`;
            } else {
                month = `${index.toString()}`;
            }

            let convertDateStart = new Date(`${year}-${month}-01`).setHours(0)

            let convertDate = new Date(convertDateStart);

            let startDate;
            let endDate;

            if (index === 1) {
                startDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth() + 1, 0);
            } else {
                startDate = new Date(convertDate.getFullYear(), convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear(), convertDate.getMonth() + 1, 0);
            }

            endDate = endDate.setHours(23,59,59,999)

            await db.collection('Dueños')
            .where('createdOn', '>=', new Date(startDate))
            .where('createdOn', '<=', new Date(endDate))
            .get()
            .then((documentSnapshots) => {
                let data = documentSnapshots.docs.map(doc => doc.data());
                data = data.filter(data => data.pais === country);
                
                customersPerMonth.push(data);
            })
        }

        dispatch({ type: 'GET_CUSTOMERS_ALL_MONTH', payload: { data: customersPerMonth } });
    }

    const getCustomersFilter = (country, page) => {
        dispatch({ type: 'GET_CUSTOMERS_FILTER_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalCustomersFilter(country, page);
        } else {
            getCustomersFilterPerCountry(page, authenticatedState.user.pais);
        }
    }

    const getGlobalCustomersFilter = (country, page) => {
        let db = firestoreInitialize();

        let first = db.collection("Dueños")

        first.get().then((documentSnapshots) => {
            let customers = documentSnapshots.docs.map(doc => doc.data())

            let nextPage;

            if (country) {
                customers = customers.filter(customer => customer.pais === country);
            }

            let nextCustomers;

            if (page === '1') {
                nextCustomers = customers.slice(10, 11);

                if (nextCustomers.length === 1) {
                    nextCustomers = true;
                } else {
                    nextCustomers = false;
                }

                customers = customers.slice(0, 10);
            } else {
                nextPage = `${page}0`;

                nextCustomers = customers.slice((parseInt(nextPage) - 10) + 10, parseInt(nextPage) + 1);

                if (nextCustomers.length === 1) {
                    nextCustomers = true;
                } else {
                    nextCustomers = false;
                }

                customers = customers.slice(parseInt(nextPage) - 10, parseInt(nextPage));
            }

            dispatch({ type: 'GET_CUSTOMERS_FILTER', payload: { data: customers, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1], next: nextCustomers } })
        })
        .catch(error => dispatch({ type: 'GET_CUSTOMERS_FILTER_ERROR', payload: { code: 'customers/error', message: error } }))     
    }

    const getCustomersFilterPerCountry = (status, page, country) => {
        let db = firestoreInitialize();

        let first = db.collection("Dueños").where("pais", "==", country)

        first.get().then((documentSnapshots) => {
            const dataFetch = documentSnapshots.docs.map(doc => doc.data())

            let newData = [];
            let nextPage;
    
          if (status) {
                if (status === 'Registrada') {
                    newData = dataFetch.filter(dataFetch => dataFetch.isApproved === true);
                } else if (status === 'Negado') {
                    newData = dataFetch.filter(dataFetch => dataFetch.isApproved === false && dataFetch.fechaCierre);
                } else {
                    newData = dataFetch.filter(dataFetch => dataFetch.fechaCierre !== null && !dataFetch.fechaCierre);
                }
            }

            let nextCustomers;

            if (page === '1') {
                nextCustomers = newData.slice(10, 11);

                if (nextCustomers.length === 1) {
                    nextCustomers = true;
                } else {
                    nextCustomers = false;
                }

                newData = newData.slice(0, 10);
            } else {
                nextPage = `${page}0`;

                nextCustomers = newData.slice((parseInt(nextPage) - 10) + 10, parseInt(nextPage) + 1);

                if (nextCustomers.length === 1) {
                    nextCustomers = true;
                } else {
                    nextCustomers = false;
                }

                newData = newData.slice(parseInt(nextPage) - 10, parseInt(nextPage));
            }

            dispatch({ type: 'GET_CUSTOMERS_FILTER', payload: { data: newData, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1], next: nextCustomers } })
        })
        .catch(error => dispatch({ type: 'GET_CUSTOMERS_FILTER_ERROR', payload: { code: 'customers/error', message: error } }))     
    }

    const getCustomersFilterExcel = (country) => {
        dispatch({ type: 'GET_CUSTOMERS_FILTER_EXCEL_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalCustomersFilterExcel(country);
        } else {
            getCustomersFilterPerCountryExcel(authenticatedState.user.pais);
        }
    }

    const getGlobalCustomersFilterExcel = (country) => {
        let db = firestoreInitialize();

        let first = db.collection("Dueños")

        first.get().then((documentSnapshots) => {
            let customers = documentSnapshots.docs.map(doc => doc.data())

            if (country) {
                customers = customers.filter(customer => customer.pais === country)
            }

            dispatch({ type: 'GET_CUSTOMERS_FILTER_EXCEL', payload: { data: customers, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1] } })
        })
        .catch(error => dispatch({ type: 'GET_CUSTOMERS_FILTER_EXCEL_ERROR', payload: { code: 'customers/error', message: error } }))     
    };

    const getCustomersFilterPerCountryExcel = (country) => {
        let db = firestoreInitialize();

        let first = db.collection("Dueños")
            .where("pais", "==", country)

        first.get().then((documentSnapshots) => {
            const dataFetch = documentSnapshots.docs.map(doc => doc.data())

            dispatch({ type: 'GET_CUSTOMERS_FILTER_EXCEL', payload: { data: dataFetch, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1] } })
        })
        .catch(error => dispatch({ type: 'GET_CUSTOMERS_FILTER_EXCEL_ERROR', payload: { code: 'customers/error', message: error } }))     
    }

    const resetCustomersState = () => {
        dispatch({ type: 'CUSTOMERS_RESET_STATE' });
    };

    const resetCustomersExcelState = () => {
        dispatch({ type: 'CUSTOMERS_EXCEL_RESET_STATE' });
    };

    return (
        <CustomersContext.Provider value={{
            customersState: state.getCustomers,
            customersByIdState: state.getCustomersById,
            customersAllMonthState: state.getCustomersAllMonth,
            createCustomersState: state.createCustomers,
            customersExcelState: state.getCustomersExcel,
            getCustomers,
            getCustomersExcel,
            getCustomersFilterExcel,
            getCustomersById,
            getCustomersByName,
            createCustomersWithExcel,
            createCustomersResetState,
            getCustomersAllMonth,
            getCustomersFilter,
            resetCustomersState,
            resetCustomersExcelState
        }}>
            {props.children}
        </CustomersContext.Provider>
    )
}

export default CustomersState;
